
import axios from "axios";
import Vue from 'vue'
import VueAxios from 'vue-axios';
import * as CryptoJS from "crypto-js";
import * as Cookies from "js-cookie";
import { api_link, SIGN_IN } from "./api";
import { checkRes, alertPop, logoutUser, errorHandle, GAPI_KEY } from "./helper";

Vue.use(VueAxios, axios)

const secret = "$%sslWireless$$_logita_revamp_fe%$";

const alert = () => {
    alertPop("error", "Something went wrong");
};

export const getData = async (query) => {
  if (Cookies.get("token")) {
    let temp = CryptoJS.AES.decrypt(Cookies.get("token"), secret);
    let token = temp.toString(CryptoJS.enc.Utf8);
    try {
      let data = await axios.get(`${api_link}${query}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (checkRes(data?.data?.code)) {
        return data;
      } else {
        if (data?.data?.messages?.length) {
          data?.data?.messages.forEach(mess => {
            alertPop("error", mess);
          });
        } else {
          alert();
        }
      }
    } catch (error) {
      if (error.response) checkRes(error?.response?.data?.code);
      if (Array.isArray(error?.response?.data?.messages)) {
        error.response.data.messages.map((err) => {
          alertPop("error", err);
        });
      } else errorHandle(error);
      return false;
    }
  } else {
    logoutUser()
  }
};

  
export const postData = async (query, data) => {
  if (Cookies.get("token")) {
    let temp = CryptoJS.AES.decrypt(Cookies.get("token"), secret);
    let token = temp.toString(CryptoJS.enc.Utf8);
    let url = `${api_link}${query}`;
    try {
      let res = await axios({
        method: "post",
        url: url,
        headers: {
          Authorization: `bearer ${token}`,
        },
        data: data,
      });

      if (checkRes(res?.data?.code)) {
        return res;
      } else {
        if (res?.data?.messages?.length) {
          res?.data?.messages.forEach(mess => {
            alertPop("error", mess);
          });
        } else {
          alert();
        }
      }
    } catch (error) {
      if (error.response) checkRes(error?.response?.data?.code);
      if (Array.isArray(error?.response?.data?.messages)) {
        error.response.data.messages.map((err) => {
          alertPop("error", err);
        });
      } else errorHandle(error);
      
      return false;
    }
  } else {
    logoutUser();
  }
};

export const login = async (data) => {
    try {
        let res = await Vue.axios.post(api_link + SIGN_IN, data)
        return res;
    } catch (error) {
        return error?.response ? error.response.data.messages : error
    }
}


export const forgetPasswordPost = async (query, data) => {
  try {
      let res = await Vue.axios.post(api_link + query, data);

      if (checkRes(res?.data?.code)) {
        return res;
      } else {
        if (res?.data?.messages?.length) {
          res?.data?.messages.forEach(mess => {
            alertPop("error", mess);
          })
        } else {
          alert();
        }
      }
  } catch (error) {
      alert();
      return error.response ? error.response.data.messages : error
  }
}

export const getWithoutToken = async (lat, lng) => {
  try {
      let res = await Vue.axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GAPI_KEY()}`);
      return res;
  } catch (error) {
      alert();
      return error.response ? error.response.data.messages : error
  }
}
